import { TableCell, Tooltip, Typography } from "@material-ui/core";
import { ChipBlock } from "componentsNew/elements/ChipBlock";
import {
  daStatusConstants,
  DISPATCHER,
  inactiveReasonConstants,
  MANAGER,
} from "constants/constants";
import { DriverData } from "types/DaAndFleet";
import { DaCheckbox } from "./DaCheckbox";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";
import { DaEditDrawerContent } from "componentsNew/drawers/drawerContent/DaEditDrawerContent";
import { DateTime } from "luxon";

export const DAStatusCell = (
  columnId: any,
  cellData: DriverData,
  classes: any,
  userRole: number,
) => {
  const cellClass = `${classes.tableCell} ${classes.fixedHeight}`;
  switch (columnId) {
    case "checkbox":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <DaCheckbox data={cellData} disabled={[DISPATCHER, MANAGER].includes(userRole)}/>
        </TableCell>
      );
    case "full_name":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          {![DISPATCHER, MANAGER].includes(userRole) ? (
            <CustomDrawer
              customWidth={440}
              buttonType={"custom"}
              drawer_name={`da-${cellData.id}-edit-drawer`}
              drawerTitle={`Edit ${cellData.first_name} ${cellData.last_name}’s Information`}
              customButtonElement={
                <Typography
                  className={classes.editButton}
                >{`${cellData.first_name} ${cellData.last_name}`}</Typography>
              }
            >
              <DaEditDrawerContent data={cellData} />
            </CustomDrawer>
          ) : (
            <Typography
              className={classes.editButtonDisabled}
            >{`${cellData.first_name} ${cellData.last_name}`}</Typography>
          )}
        </TableCell>
      );
    case "status":
      const status = cellData.status;
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {
              <ChipBlock
                text={daStatusConstants.find((data) => data.value === status)?.label}
                theme={
                  status === 1 ? "green" : status === 3 ? "red" : status === 6 ? "yellow" : "gray"
                }
              />
            }
          </Typography>
        </TableCell>
      );
    case "stations":
      const stationString = cellData.station_spots?.map((spot) => spot.station.title).join(", ");
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          {stationString.length > 29 ? (
            <Tooltip title={stationString}>
              <Typography>{`${stationString.slice(0, 30)}...`}</Typography>
            </Tooltip>
          ) : (
            <Typography>{stationString}</Typography>
          )}
        </TableCell>
      );
    case "payroll":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {cellData.station_spots?.length ? cellData.station_spots[0].agency.name : ""}
          </Typography>
        </TableCell>
      );
    case "last_edit":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {cellData.last_edit && cellData.last_edited_by
              ? `${cellData.last_edit} by ${cellData.last_edited_by}`
              : "---"}
          </Typography>
        </TableCell>
      );
    case "fleet_groups":
      const groupString = cellData.station_spots?.length
        ? cellData?.station_spots[0]?.fleet_groups?.map((group) => group.name).join(", ")
        : "";
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          {groupString.length > 29 ? (
            <Tooltip title={groupString}>
              <Typography>{`${groupString.slice(0, 30)}...`}</Typography>
            </Tooltip>
          ) : (
            <Typography>{groupString}</Typography>
          )}
        </TableCell>
      );
    case "created":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>{DateTime.fromISO(cellData.created).toFormat("dd-MM-yyyy")}</Typography>
        </TableCell>
      );
    case "status_change_reason":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {cellData.status === 5
              ? inactiveReasonConstants.find(
                  (reason) => reason.value === cellData.status_change_reason,
                )?.option
              : ""}
          </Typography>
        </TableCell>
      );
    default:
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>{cellData ? cellData[columnId as keyof DriverData] : "---"}</Typography>
        </TableCell>
      );
  }
};
